import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.tsx'
import { useToast } from '@/components/ui/toast.tsx'
import { $account } from '@/models/account.ts'
import { handleError } from '@/utils/error'

import { useUpdateTeamTable } from '../../hooks/use-update-table'
import type { TeamMemberActionsProps } from './list/team-actions'

export const TeamMemberRoleChanger = ({ row }: TeamMemberActionsProps) => {
  const { updateMember } = useUpdateTeamTable()
  const account = useUnit($account)

  const toast = useToast()

  const currentSelectedRole = row.original.role

  const handleRoleChange = async (newRole: TeamMemberRole) => {
    const updatedUserData = {
      ...row.original,
      role: newRole,
    }

    await updateMember
      .mutateAsync(updatedUserData)
      .then(() => {
        toast.success('Successfully updated user role')
      })
      .catch((error) => {
        handleError(
          error,
          'Something went wrong while updating the user role. Try again later!',
        )
      })
  }

  if (
    account?.memberRole !== TeamMemberRole.LEADER ||
    currentSelectedRole === 'Leader'
  ) {
    return <span>{currentSelectedRole}</span>
  }

  return (
    <Select
      onValueChange={handleRoleChange}
      value={currentSelectedRole}
    >
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="Admin">Admin</SelectItem>
          <SelectItem value="Member">Member</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
